'use client';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import Image from 'next/image';
import Popover from 'antd/es/popover';
import { generateGUID, mapModifiers, notify } from '@/utils/funtion';
import Input from '@/components/atoms/Input';
import imgAI from '@/assets/images/chatbot.png';
import {
  FaDatabase,
  FaTelegramPlane,
  FaExpandAlt,
  FaSpider,
} from 'react-icons/fa';
import { Tooltip } from 'antd';
import Modal from '@/components/molecules/modal';
import { useData } from '@/stores/context';
import logo from '@/assets/images/logo.png';
import { useSocket } from '@/stores/context/socketProvider';
import Markdown from '@/components/molecules/markdown';
import { FaCheck } from 'react-icons/fa';
import Icon from '@/components/atoms/icon';
import { FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { addMessage, resetMessages } from '@/stores/modules/chatBotMessages';
import { SendMessage, SendMessageChatbot } from '@/services/apis/modules/ai';
import { checkDownloadStatus } from '@/services/apis/modules/plans';
import { FaSquareXmark } from 'react-icons/fa6';
import {
  addMessageAssistant,
  resetMessagesAssistant,
} from '@/stores/modules/chatBotMessagesAssistant';
import Link from 'next/link';

type Status = 'chatbot' | 'popup' | 'hide';

const messages = [
  'Xin chào bạn, mình là trợ lí ảo',
  'Mình có thể giúp gì cho bạn không?',
  'Bạn cần mình phân tích dữ liệu này không?',
  'Bạn có muốn xem thống kê mới nhất không?',
  'Có dữ liệu nào bạn muốn mình kiểm tra không?',
  'Bạn muốn mình hỗ trợ tìm kiếm thông tin gì không?',
  'Mình có thể tóm tắt dữ liệu giúp bạn nhé!',
  'Bạn có cần hướng dẫn cách đọc biểu đồ không?',
];

interface IProps {
  id?: string;
  name?: string;
  typeData?: string;
}

const Assistant: React.FC<IProps> = ({ id, name, typeData }) => {
  const dispatch = useDispatch();
  const messagesStore = useSelector((state: any) => state.chat.messages);
  const messagesAssistantStore = useSelector(
    (state: any) => state.chatAssistant.messages,
  );
  const { socket, listen } = useSocket();
  const { handleSetDataQuestion, dataQuestion } = useData();
  const [assistantStatus, setAssistantStatus] = useState<Status>('hide');
  const [isChatBot, setIsChatBot] = useState(false);
  const [message, setMessage] = useState(messages[0]);
  const [visible, setVisible] = useState(false);
  const { statusAssitant, handleSetStatusAssitant } = useData();
  const [result, setResult] = useState('');
  const streamMap = useRef<Map<number, string>>(new Map());
  const lastProcessedIndex = useRef(-1);
  const [userInput, setUserInput] = useState('');
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [indicatorMentions, setIndicatorMentions] = useState<any>([]);

  useEffect(() => {
    return () => {
      dispatch(resetMessages());
      dispatch(resetMessagesAssistant());
    };
  }, []);
  // console.log('messagesAssistantStore', messagesAssistantStore);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }, [result]);

  useEffect(() => {
    if (assistantStatus === 'hide') {
      const messageInterval = setInterval(() => {
        setMessage((prevMessage) => {
          const currentIndex = messages.indexOf(prevMessage);
          const nextIndex = (currentIndex + 1) % messages.length;
          return messages[nextIndex];
        });
      }, 20000);

      return () => clearInterval(messageInterval);
    }
  }, [assistantStatus]);

  useEffect(() => {
    if (!statusAssitant) return;
    setAssistantStatus(statusAssitant as Status);
  }, [statusAssitant]);

  useEffect(() => {
    if (assistantStatus === 'hide') {
      setVisible(true);
      const hideTimer = setTimeout(() => setVisible(false), 5000);
      return () => clearTimeout(hideTimer);
    }
  }, [message, assistantStatus]);

  useEffect(() => {
    setResult('');
    streamMap.current.clear();
    lastProcessedIndex.current = -1;
  }, [dataQuestion, messagesStore]);

  useEffect(() => {
    if (!dataQuestion.trim()) return;
    listen(dataQuestion, (data: { index: number; content: string }) => {
      streamMap.current.set(data.index, data.content);
      const sortedStream = Array.from(streamMap.current.entries()).sort(
        ([a], [b]) => a - b,
      );

      let newContent = '';
      sortedStream.forEach(([index, content]) => {
        if (index > lastProcessedIndex.current) {
          newContent += content;
          lastProcessedIndex.current = index;
        }
      });

      if (newContent) {
        setResult((prev) => prev + newContent);
      }
    });
  }, [socket, dataQuestion, messagesStore, messagesAssistantStore]);
  console.log('dataQuestion', dataQuestion);

  const handleSendMessageToAnalyte = async (
    isSendQuestion: boolean,
    text?: string,
  ) => {
    if (loading) return;
    try {
      const body = {
        id: id,
        type: typeData,
        message: isSendQuestion
          ? userInput
          : `Hãy phân tích chuyên sâu chỉ số ${name} và trả về theo định dạng markdown`,
        messageId: dataQuestion,
      };
      if (!isSendQuestion) {
        dispatch(
          addMessage({ sender: 'user', text: text ? text : 'Tôi đồng ý!' }),
        );
      } else {
        dispatch(addMessage({ sender: 'user', text: userInput }));
      }
      setLoading(true);
      await SendMessage(body)
        .then((res) => {
          if (res?.status) {
            setResult('');
            dispatch(addMessage({ sender: 'bot', text: res?.data }));
            setUserInput('');
            setLoading(false);
          } else {
            setUserInput('');
            setLoading(false);
            setResult('');
          }
        })
        .catch((error) => {
          notify('error', 'có lỗi xảy ra:', 'top-right');
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      notify('error', 'có lỗi xảy ra: ' + error);
      console.error('Error sending message to analyte:', error);
      setUserInput('');
      setLoading(false);
      setResult('');
    }
  };

  const handleSendMessageChatBot = async (isAnalysis?: boolean, item?: any) => {
    if (loading) return;
    try {
      const body: any = {
        message: isAnalysis ? item.id : userInput,
        messageId: dataQuestion,
      };
      if (isAnalysis && item) {
        body.type = item.type;
      }

      dispatch(
        addMessageAssistant({
          sender: 'user',
          text: isAnalysis ? 'Phân tích chỉ số ' + item.name : userInput,
        }),
      );
      setLoading(true);
      await SendMessageChatbot(body)
        .then((res) => {
          console.log('res', res);
          if (res?.status) {
            setResult('');
            dispatch(addMessageAssistant({ sender: 'bot', text: res?.data }));
            if (Array.isArray(res?.data)) {
              setIndicatorMentions((prev: any) => {
                const existingIds = new Set(prev.map((item: any) => item.id));
                const newItems = res.data.filter(
                  (item: any) => !existingIds.has(item.id),
                );
                return [...prev, ...newItems];
              });
            }
            setUserInput('');
            setLoading(false);
          } else {
            setUserInput('');
            setLoading(false);
            setResult('');
          }
        })
        .catch((error) => {
          notify('error', 'có lỗi xảy ra:', 'top-right');
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      notify('error', 'có lỗi xảy ra: ' + error);
      console.error('Error sending message to analyte:', error);
      setUserInput('');
      setLoading(false);
      setResult('');
    }
  };

  const handleCheckDownloadStatus = async (
    isSendQuestion: boolean,
    text?: string,
  ) => {
    if (messagesStore.length === 1) {
      handleSendMessageToAnalyte(isSendQuestion, text);
      return;
    }
    await checkDownloadStatus({
      type: 'ai_data_analysis',
      groupData: 'ai_data_analysis',
    }).then((response) => {
      if (response?.status) {
        const { data } = response;
        if (data?.downLoadStatus) {
          handleSendMessageToAnalyte(isSendQuestion, text);
        } else {
          notify('error', 'Bạn đã hết lượt sử dụng AI');
        }
      } else {
        notify('warning', 'Xảy ra lỗi', 'top-right');
      }
    });
  };

  const handleCheckDownloadStatusChatBot = async (
    isAnalysis?: boolean,
    item?: any,
  ) => {
    await checkDownloadStatus({
      type: 'ai_data_analysis',
      groupData: 'ai_data_analysis',
    }).then((response) => {
      if (response?.status) {
        const { data } = response;
        if (data?.downLoadStatus) {
          handleSendMessageChatBot(isAnalysis, item);
        } else {
          notify('error', 'Bạn đã hết lượt sử dụng AI');
        }
      } else {
        notify('warning', 'Xảy ra lỗi', 'top-right');
      }
    });
  };
  const renderUIAssistant = useMemo(() => {
    switch (assistantStatus) {
      case 'hide':
      // return (
      //   <Popover
      //     autoAdjustOverflow
      //     placement="leftTop"
      //     content={message}
      //     open={visible}
      //   >
      //     <div
      //       className="t-assistant-hide_icon"
      //       onClick={() => {
      //         setAssistantStatus('chatbot');
      //         setIsChatBot(true);
      //         handleSetDataQuestion(generateGUID());
      //       }}
      //     >
      //       <Image src={imgAI} alt="AI" />
      //     </div>
      //     <div className="t-assistant-hide_icon1" />
      //     <div className="t-assistant-hide_icon2" />
      //     <div className="t-assistant-hide_icon3" />
      //   </Popover>
      // );
      // return null;
      case 'chatbot':
        return null;
      // return (
      //   <div className="t-assistant-chatbot_wrapper">
      //     <div className="t-assistant-chatbot_header">
      //       <div className="t-assistant-chatbot_header_name">
      //         {/* <FaSpider />
      //         <h4>Huyền Trang Assistant</h4> */}
      //         <Image src={logo} alt="logo" />
      //         <h4>Vietstats Assistant</h4>
      //       </div>
      //       <div className="t-assistant-chatbot_header_icon">
      //         <Tooltip title="Phóng to">
      //           <FaExpandAlt onClick={() => setAssistantStatus('popup')} />
      //         </Tooltip>
      //         <Tooltip title="Đóng">
      //           <FaSquareXmark
      //             style={{ color: '#f00', fontWeight: 600 }}
      //             onClick={() => {
      //               setAssistantStatus('hide');
      //               setIsChatBot(false);
      //               dispatch(resetMessagesAssistant());
      //             }}
      //           />
      //         </Tooltip>
      //       </div>
      //     </div>
      //     <div className="t-assistant-chatbot_content">
      //       <div className="t-assistant-chatbot_content_wrapper">
      //         {messagesAssistantStore.map((msg: any, index: number) => (
      //           <div
      //             key={index}
      //             className={mapModifiers(
      //               't-assistant-chatbot_content_item',
      //               msg.sender === 'user' ? 'iam' : '',
      //             )}
      //           >
      //             {msg.sender === 'bot' &&
      //               (Array.isArray(msg.text) ? (
      //                 <>
      //                   <div className="t-assistant-chatbot_content_item_arr">
      //                     <p>Tôi tìm được một vài chỉ số sau:</p>
      //                     {msg.text.map((item: any, index: number) => (
      //                       <div
      //                         key={index}
      //                         className="t-assistant-chatbot_content_item_arr_item"
      //                       >
      //                         - {item?.name}
      //                         <Link
      //                           target="_blank"
      //                           href={`/thong-tin-chi-tiet/${'slug'}/${item?.id}?type=${item?.type}&area=${'VN'}&structure=${item?.is_structure}&isObjectOneTime=${item?.is_object_one_time}`}
      //                         >
      //                           {' '}
      //                           [Chi tiết]
      //                         </Link>
      //                         <span
      //                           onClick={() => {
      //                             handleCheckDownloadStatusChatBot(
      //                               true,
      //                               item,
      //                             );
      //                           }}
      //                         >
      //                           {' '}
      //                           [Phân tích]
      //                         </span>
      //                       </div>
      //                     ))}
      //                     <p>Bạn cần tôi phân tích chỉ số nào không?</p>
      //                   </div>
      //                 </>
      //               ) : (
      //                 <Markdown value={msg.text} />
      //               ))}
      //             {msg.sender === 'user' && <p>{msg.text}</p>}
      //           </div>
      //         ))}
      //         {loading && (
      //           <div
      //             className={mapModifiers('t-assistant-chatbot_content_item')}
      //           >
      //             <Markdown value={result} />
      //           </div>
      //         )}
      //         <div ref={messagesEndRef} />
      //       </div>
      //     </div>
      //     <div className="t-assistant-chatbot_footer">
      //       {/* <Tooltip title="Sử dụng dữ liệu này để phân tích">
      //         <FaDatabase />
      //       </Tooltip> */}
      //       <Input
      //         value={userInput}
      //         onChange={(e) => setUserInput(e.target.value)}
      //         placeholder="Nhập nội dung bạn cần hỏi..."
      //         onPressEnter={() => {
      //           handleCheckDownloadStatusChatBot();
      //         }}
      //       />
      //       <Tooltip title="Gửi">
      //         <FaTelegramPlane
      //           onClick={() => {
      //             handleCheckDownloadStatusChatBot();
      //           }}
      //         />
      //       </Tooltip>
      //     </div>
      //   </div>
      // );
      case 'popup':
        return (
          <Modal
            open={assistantStatus === 'popup'}
            onCancel={() => {
              handleSetDataQuestion('');
              setUserInput('');
              dispatch(resetMessages());
              if (isChatBot) {
                setAssistantStatus('chatbot');
              } else {
                setAssistantStatus('hide');
                handleSetStatusAssitant('hide');
              }
            }}
            maskClosable={false}
            footer={false}
            width={'80vw'}
            centered
            titleWithTemplate
            template={
              <div className="t-assistant-popup_header">
                <Image src={logo} alt="logo" />
                <h4>Vietstats Assistant</h4>
              </div>
            }
          >
            <div className="t-assistant-popup_wrapper">
              <div className="t-assistant-popup_content">
                <div className="t-assistant-popup_content_wrapper">
                  {(isChatBot ? messagesAssistantStore : messagesStore)?.map(
                    (msg: any, index: any) => (
                      <>
                        <div
                          key={index}
                          className={mapModifiers(
                            't-assistant-popup_content_item',
                            msg.sender === 'user' ? 'iam' : '',
                          )}
                        >
                          {msg.sender === 'bot' &&
                            (Array.isArray(msg.text) ? (
                              <>
                                <div className="t-assistant-popup_content_item_arr">
                                  <p>Tôi tìm được một vài chỉ số sau:</p>

                                  {msg.text.map((item: any, index: number) => {
                                    return (
                                      <div
                                        key={index}
                                        className="t-assistant-popup_content_item_arr_item"
                                      >
                                        - {item?.name}
                                        <Link
                                          target="_blank"
                                          href={`/thong-tin-chi-tiet/${'slug'}/${item?.id}?type=${item?.type}&area=${'VN'}&structure=${item?.is_structure}&isObjectOneTime=${item?.is_object_one_time}`}
                                        >
                                          {' '}
                                          [Chi tiết]
                                        </Link>
                                        <span
                                          onClick={() => {
                                            handleCheckDownloadStatusChatBot(
                                              true,
                                              item,
                                            );
                                          }}
                                        >
                                          {' '}
                                          [Phân tích]
                                        </span>
                                      </div>
                                    );
                                  })}
                                  <p>Bạn cần tôi phân tích chỉ số nào không?</p>
                                </div>
                              </>
                            ) : (
                              <Markdown value={msg.text} />
                            ))}
                          {msg.sender === 'user' && <p>{msg.text}</p>}

                          {(isChatBot ? messagesAssistantStore : messagesStore)
                            ?.length === 1 &&
                            !isChatBot && (
                              <>
                                <Icon
                                  className="check"
                                  onClick={() => {
                                    handleCheckDownloadStatus(false);
                                  }}
                                  component={<FaCheck />}
                                />{' '}
                                <Icon
                                  className="time"
                                  onClick={() => {
                                    dispatch(
                                      addMessage({
                                        sender: 'user',
                                        text: 'Tôi không cần!',
                                      }),
                                    );
                                    dispatch(
                                      addMessage({
                                        sender: 'bot',
                                        text: 'Vâng, nếu bạn cần gì thì đặt câu hỏi nhé',
                                      }),
                                    );
                                  }}
                                  component={<FaTimes />}
                                />
                              </>
                            )}
                        </div>
                      </>
                    ),
                  )}
                  {loading && (
                    <div
                      className={mapModifiers('t-assistant-popup_content_item')}
                    >
                      <Markdown
                        value={result
                          .replaceAll(/\\\[/g, '$$')
                          .replaceAll(/\\\]/g, '$$')
                          .replaceAll(/\\\((.*?)\\\)/g, '$$$1$')}
                      />
                    </div>
                  )}
                  <div ref={messagesEndRef} />
                </div>
              </div>
              <div className="t-assistant-popup_footer">
                <div className="t-assistant-popup_footer_wrapper">
                  {isChatBot || (
                    <Tooltip title="Sử dụng dữ liệu này để phân tích">
                      <FaDatabase
                        onClick={() => {
                          handleCheckDownloadStatus(
                            false,
                            'Hãy phân tích chỉ số này',
                          );
                        }}
                      />
                    </Tooltip>
                  )}
                  <Input
                    type="textarea"
                    placeholder="Nhập nội dung bạn cần hỏi..."
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    onPressEnter={() => {
                      if (!userInput.trim()) return;
                      if (isChatBot) {
                        handleCheckDownloadStatusChatBot();
                      } else {
                        handleCheckDownloadStatus(true);
                      }
                    }}
                    disabled={loading}
                  />
                  <Tooltip title="Gửi">
                    <FaTelegramPlane
                      onClick={() => {
                        if (!userInput.trim()) return;
                        if (isChatBot) {
                          handleCheckDownloadStatusChatBot();
                        } else {
                          handleCheckDownloadStatus(true);
                        }
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          </Modal>
        );
      default:
        return <div></div>;
    }
  }, [
    assistantStatus,
    message,
    visible,
    result,
    loading,
    userInput,
    messagesStore,
    messagesAssistantStore,
    isChatBot,
  ]);

  return (
    <div className={mapModifiers('t-assistant', assistantStatus)}>
      {renderUIAssistant}
    </div>
  );
};

export default Assistant;
